import React from 'react';
import { Link } from 'react-router-dom';

export const Hero = () => {
    return (
        <section className="min-h-screen relative flex items-center justify-center bg-black">
            <div className="text-center">
                <h1 className="text-white text-6xl font-bold">YESSUHCHILL</h1>
                <p className="text-lime mt-4">Shop Now</p>
                <Link to="/products" className="mt-8 inline-block bg-lime text-black px-8 py-4 font-bold">
                    SHOP NOW
                </Link>
            </div>
        </section>
    );
};
